module.exports = __webpack_public_path__ + "img/srry.e8e99c61.svg";